(() => {
  const accountPath = '/account';

  const normalizeAccountLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);

        if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === '/pages/mijn-account') {
          link.href = accountPath;
        }
      } catch (_) {
        // Keep malformed or third-party links untouched.
      }
    });
  };

  if (window.location.pathname.replace(/\/$/, '') === '/pages/mijn-account') {
    window.location.replace(accountPath);
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeAccountLinks(), { once: true });
  } else {
    normalizeAccountLinks();
  }
})();
